import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { InviteEarnService } from '@app-services/invite-earn/invite-earn.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-champion',
  templateUrl: './champion.component.html',
  styleUrls: ['./champion.component.css']
})

export class ChampionComponent implements OnInit {
  batchName: any;
  perc: any;
  description: any;
  mUserREfId: any = localStorage.getItem('mUserRefId');
  textAreaLink: any = localStorage.getItem('textAreaLink');
  mUserREfLink: any;
  mUserREfLinkFb: any;
  mUserREfLinkInst: any;
  badthImg: any;
  referralObj: any;
  user: any;
  public rootUrl:any;
  rewardDescription: any;
  constructor(private dialog: MatDialog,

    private _inviteService: InviteEarnService,
    private router: Router,
    private _toastr: ToastrService,
    private dialogRef: MatDialogRef<ChampionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    this.user = this._inviteService.getUserInfo();
    this.batchName = this.data?.batchNamePopup;
    this.perc = this.data?.percentageBadges;
    this.description = this.data?.badgeDescription;
    this.rewardDescription =  this.data?.rewardDescription
    this.rootUrl=this.data.shareUrl;
    this.badthImg = this.data?.badgesImage;
    if (this.data?.showGifImage) {

    }

  }

  ngAfterViewInit(): void {
    this.getRefCode(this.user.userId, this.user.name);
  }

  closeDialog() {
    this.dialogRef.close(this.perc == 100);
  }

  //get refcode
  getRefCode(userId: any, userName: any) {
    this._inviteService.generateReferralCode(userId, userName).subscribe({
      next: (data) => {
        this.referralObj = data;
        this.textAreaLink = this.referralObj.deepLink;

        this.referralObj.deepLink = "Yay! I have earned" + " " + this.batchName + " " + "badge on Infinity Learn. Join me and let’s learn together \n" + this.referralObj.deepLink;
        this._inviteService.setRefToLocalStorage(this.referralObj?.userReferralId, this.referralObj?.deepLink, this.textAreaLink);
      }, error: (err) => { }
    })
  }

  // Yay! I have earned {badge name} on Infinity Learn. Join me and let’s learn together
  sendModeOfShare(modeOfShare: any) {
    this._inviteService.sendModeOfShareDetails(modeOfShare, this.referralObj?.userReferralId).subscribe((res) => {
    })
  }

  //copy refcode
  copyRefCode() {
    this._toastr.success("Text Copied!")
    navigator.clipboard.writeText("Yay! I have earned" + " " + this.batchName + " " + "badge on Infinity Learn. Join me and let’s learn together \n" + this.textAreaLink);

  }

  navigateAllBadges(){
    this.router.navigate(['/dashboard/myactivity/achievements']);
    this.dialogRef.close();
  }

}
